import * as React from 'react';
import '../css/top-banner.sass';
import StaticElementButton from './StaticElementButton';

interface MessageType {
  type: string;
  message: React.ReactNode;
}

interface TopBannerState {
  currentIndex: number;
}

interface TopBannerProps {
  messages: MessageType[];
}
export default function TopBanner(props: TopBannerProps) {
  const [state, setState] = React.useState<TopBannerState>({
    currentIndex: 0
  });

  const showNextMsg = () => {
    setState({
      currentIndex: state.currentIndex + 1
    });
  };

  const showPreviousMsg = () => {
    setState({
      currentIndex: state.currentIndex - 1
    });
  };

  const message = props.messages[state.currentIndex];
  const messagesLength = props.messages.length;
  return (
    <div id="topbanner" className={`topbanner ${message.type}`}>
      <div className="bannerContent">
        <span className="icon" />
       <span>{message.message}</span>
      </div>
      {messagesLength > 1 && (
        <div className="pagination">
          {state.currentIndex > 0 ? (
            <StaticElementButton
              name="premesage"
              id="preMessage"
              label="Previous Message"
              type="span"
              onClick={showPreviousMsg}
            >
              &lt;
            </StaticElementButton>
          ) : (
            <span style={{ cursor: 'default' }}>&nbsp;&nbsp;</span>
          )}
          <span>
            Message {state.currentIndex + 1} of {messagesLength}
          </span>
          {state.currentIndex < messagesLength - 1 ? (
            <StaticElementButton
              name="nextmesage"
              id="nextMessage"
              label="Next Message"
              type="span"
              onClick={showNextMsg}
            >
              &gt;
            </StaticElementButton>
          ) : (
            <span style={{ cursor: 'default' }}>&nbsp;&nbsp;</span>
          )}
        </div>
      )}
    </div>
  );
}
